import {
  TimelineMax,
  Expo,
  Elastic,
  TweenMax,
} from 'gsap';
import { padStart } from 'lodash';

const Loader = (element) => {
  const loader = element.querySelector('.loader');
  const content = element.querySelector('.loader__content');
  const counter = element.querySelector('.loader__counter');
  const background = element.querySelector('.loader__background');

  const isSafari = () => {
    return navigator.userAgent.toLowerCase().indexOf('safari') > -1
    && navigator.userAgent.toLowerCase().indexOf('chrome') === -1;
  };

  const isTouchDevice = () => {
    return window.matchMedia('(pointer: coarse) and (hover: none)').matches;
  };

  const tl = new TimelineMax({ paused: true });
  const p = { v: 0, clip: 100 };
  let ratio = window.innerWidth / window.innerHeight;
  if (ratio > 1) ratio = window.innerHeight / window.innerWidth;
  tl.addLabel('start')
    .set(loader, {
      webkitClipPath: 'circle(100% at 50% 50%)',
      clipPath: 'circle(100% at 50% 50%)',
    })
    .to(p, 2, {
      v: 100,
      ease: Expo.easeIn,
    }, 'start')
    .addLabel('close');
  if (isSafari()) tl.to(loader, 0.6, { autoAlpha: 0, ease: Expo.easeInOut }, 'close');
  tl
    .to(p, 1.4, {
      clip: !isTouchDevice() ? (22 / (background.getBoundingClientRect().width / ratio)) * 100 : 0,
      ease: Elastic.easeOut.config(1, 1),
    }, !isSafari() ? 'close' : 'close+=0.6')
    .set(loader, { autoAlpha: 0 })
    .set(loader, { display: 'none' });

  tl.eventCallback('onUpdate', () => {
    counter.innerText = padStart(Math.round(p.v), 3, '00');
    if (!isSafari()) {
      TweenMax.set(loader, {
        webkitClipPath: `circle(${Math.abs(p.clip)}% at 50% 50%)`,
        clipPath: `circle(${Math.abs(p.clip)}% at 50% 50%)`,
      });
    }
  });
  return tl;
};

export default Loader;
